import omit from 'lodash/omit';

import Grid from '@mui/material/Grid';

import ReportTable from './ReportTable';

const WeeklyProviderActuationSummaryReport = ({
  reportData, 
}) => {
  const tableData = reportData?.data?.[0];
  return (
    <>
      <ReportTable
        title={tableData?.name || ''}
        columns={tableData?.columns || []} 
        rows={tableData?.rows || []}
      />
    </>
  );
};

export default WeeklyProviderActuationSummaryReport;